import { LocalBrick } from './LocalBrick'

export abstract class ServerBrick extends LocalBrick {
    constructor(license?: string) {
        super(license)
    }
}
